<template>
  <div class="modal">
    <div class="modal-content">
      <h1
        class="w-full mb-6 text-xl font-semibold tracking-wide text-gray-800 uppercase"
      >
        Snippet zum Einbetten
      </h1>
      <div class="mb-2">
        <textarea
          v-model="snippet"
          class="w-full h-32 p-4 text-white bg-gray-800 rounded-lg outline-none resize-none"
          readonly
          @click="copy"
        />
        <span
          v-if="copied"
          class="text-green-700"
        >
          Snippet in Zwischenablage kopiert
        </span>
      </div>
    </div>
    <div class="modal-footer">
      <button
        class="btn-primary"
        @click="$emit('close')"
      >
        Schließen
      </button>
    </div>
  </div>
</template>

<script>
import GET_CMS_ORGANIZATION from '@/graphql/GetCmsOrganization.gql'

const widgetMap = {
  CHECKLIST: 'download',
  GUIDE: 'download',
  RETURN_CALL: 'return-call',
  VALUATION: 'valuation',
  PLOT_VALUATION: 'plot-valuation',
  PROPERTY_REQUEST: 'property-request',
  LIFE_ANNUITY: 'life-annuity',
  PARTIAL_SALE: 'partial-sale',
  QUIZZARD: 'quizzard',
  LIST: 'list'
}

export default {
  props: {
    companyId: {
      type: String,
      required: true
    },
    companySlug: {
      type: String,
      required: true
    },
    landingpageSlug: {
      type: String,
      required: true
    },
    landingpageType: {
      type: String,
      required: true
    }
  },
  data: () => ({
    copied: false
  }),
  computed: {
    widget () {
      return widgetMap[this.landingpageType] || ''
    },
    parameters () {
      if (['CHECKLIST', 'GUIDE', 'QUIZZARD'].includes(this.landingpageType)) {
        return `slug="${this.landingpageSlug}"`
      }

      if (this.landingpageType === 'LIST') {
        const type = this.landingpageSlug.split('-')[1] === 'ratgeber' ? 'GUIDE' : 'CHECKLIST'
        return `slug="${type}"`
      }

      return ''
    },

    snippet () {
      if (!this.cmsOrganization) return ''
      const { widgetUrl, id, defaultLocale } = this.cmsOrganization
      return `<script src="${widgetUrl}/components/${id}/btm-widget/${defaultLocale}" defer><\/script>\n<btm-widget widget="${this.widget}" ${this.parameters}></btm-widget>` // eslint-disable-line no-useless-escape
    }
  },
  apollo: {
    cmsOrganization: {
      query: GET_CMS_ORGANIZATION,
      variables () {
        return {
          companyId: this.companyId
        }
      },
      skip () {
        return !this.companyId
      }
    }
  },
  methods: {
    copy (evt) {
      evt.target.select()
      document.execCommand('copy')
      this.copied = true
    }
  }
}
</script>
